import React from "react";
import Tooltip from "@mui/material/Tooltip";
import "./CompanyBooks.css";
import { BreadcrumbAdmin } from "../../../../UI/BreadcrumbAdmin";
import { useGetCompanyByIdQuery } from "../../../../../redux-toolkit/features/company/companyApiSlice";
import { useGetBooksQuery } from "../../../../../redux-toolkit/features/books/bookApiSlice";
import ProgressBar from "../../../../UI/ProgressBar";
import { useParams } from "react-router-dom";
import { Error404 } from "../../../../UI/404/Error404";
import { NoRecord } from "../../../../UI/No record/NoRecord";

const fallbackImage =
  "https://images.unsplash.com/photo-1589251204996-3367cc27f084?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1155&q=80";

const base = [
  {
    _id: 1,
    link: "/super-admin/manage-organization/companies",
    label: "Company",
  },
];

export const CompanyBooks = () => {
  const { companyId } = useParams();
  const {
    data: companyData,
    isLoading: isCompanyLoading,
    isError: isCompanyError,
  } = useGetCompanyByIdQuery(
    { companyId },
    {
      refetchOnMountOrArgChange: true,
      skip: !companyId,
    },
  );
  const { data, isLoading, isError } = useGetBooksQuery(
    { type: "COMPANY", selectedCompany: companyId },
    {
      refetchOnMountOrArgChange: true,
      skip: !companyId,
    },
  );

  if (isError || isCompanyError) {
    return <Error404 />;
  }
  if (isLoading || isCompanyLoading) {
    return <ProgressBar />;
  }

  const books = data?.data?.books ?? [];

  return (
    <div className="container">
      <BreadcrumbAdmin base={base} page={companyData?.data?.name} />
      <div className="companyBooks">
        {books.map((curElm, index) => (
          <div key={curElm._id || index} className="companyBooksCards">
            <img
              src={curElm.coverImage || fallbackImage}
              alt={curElm.name || ""}
            />
            <div className="companyBooksCards__content">
              <h5 className="ftwt__m">{curElm.name}</h5>
              <div className="seprator"></div>
              <Tooltip
                title={curElm.description || ""}
                arrow
                placement="top"
                slotProps={{
                  tooltip: {
                    sx: {
                      maxWidth: 280,
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: 1.5,
                    },
                  },
                }}
              >
                <p className="companyBooksCards__description">
                  {curElm.description}
                </p>
              </Tooltip>
            </div>
          </div>
        ))}
        {books.length <= 0 && <NoRecord />}
      </div>
    </div>
  );
};
